import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const HeaderContainer = styled.div`
    ${BaseStyle.Mixins.screenSizes.medium} {
        margin-top: 16px;
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        margin-top: 24px;
    }
`;

export const OddsAndStoriesContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    ${BaseStyle.Mixins.gaps.medium};
    margin-top: 16px;
`;

export const DayContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    ${BaseStyle.Mixins.gaps.large}
    padding-top: 24px;
`;
